import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/grupos/employees";
import employees from "../../models/grupos/employees";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    employees: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    openEmployees: false,
    mode: "Agregar empleado",
    openDelete: false,
  },

  mutations: {
    setEmployees(state, data) {
      state.employees = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },

    setNew(state, data) {
      state.new = data;
    },
    setOpenEmployees(state, data) {
      state.openEmployees = data;
    },
    setMode(state, data) {
      state.mode = data;
    },

    setOpenDelete(state, data) {
      state.openDelete = data;
    },
  },
  actions: {
    async getEmployees(state, id) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getEmployees(id);

          state.commit("setEmployees", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(({ data }) => {
            let item = state.state.edit;
            let options = state.state.employees;
            options = options.map((option) => {
              if (option.empId != item.empId) {
                return option;
              }
              item = employees.fromJson({
                grupoId: item.groupId,
                empId: item.empId,
                fecDesde: item.from,
                fecHasta: data.hasta,
                apellido: item.lastName,
                nombres: item.name,
              });
              return item;
            });

            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.employees;
            let newItem = employees.fromJson({
              grupoId: item.groupId,
              empId: item.empId,
              fecDesde: item.from,
              fecHasta: data.hasta,
              apellido: item.lastName,
              nombres: item.name,
            });
            options.push(newItem);

            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.employees;
            options = options.filter((option) => {
              return option.empId != state.state.deleteItem.empId;
            });
            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
